import { useEffect, useState } from 'react'

/**
 * `value`, settling `delayMs` after it last changed.
 *
 * The first render returns the value as given rather than waiting, so a feed
 * keyed on the result makes its initial read at once.
 */
export const useDebouncedValue = <T,>(value: T, delayMs: number): T => {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return settled
}
